import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URI}/api/sprints`
});

export const getSprints = async (projectId) => {
  const response = await API.get("/", { params: { project_id: projectId } });
  return response.data;
};

export const createSprint = async (data) => {
  const response = await API.post("/", data);
  return response.data;
};

export const updateSprint = async (sprintId, data) => {
  const response = await API.put(`/${sprintId}`, data);
  return response.data;
};

export const deleteSprint = async (sprintId) => {
  const response = await API.delete(`/${sprintId}`);
  return response.data;
};
